import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Services from './components/Services';
import Team from './components/Team';
import Testimonial from './components/Testimonial';
import CTA from './components/CTA';
import Footer from './components/Footer';
import { SchemaOrg, getOrganizationSchema, getWebSiteSchema, getServiceSchema, getFAQSchema } from '../../utils/seo';

export default function Home() {
  useEffect(() => {
    document.title = 'CodeLiance | Desarrollo Software & IA para Empresas | Colombia';
  }, []);

  return (
    <>
      <SchemaOrg type="Organization" data={getOrganizationSchema()} />
      <SchemaOrg type="WebSite" data={getWebSiteSchema()} />
      <SchemaOrg type="Service" data={getServiceSchema()} />
      <SchemaOrg type="FAQPage" data={getFAQSchema()} />
      
      {/* Contenedor Principal con Fondo Base Negro Absoluto */}
      <div className="min-h-screen bg-[#050608] relative selection:bg-[#00C2FF]/30">
        
        {/* CAPA DE LUZ GLOBAL: Estos elementos eliminan los cortes entre secciones */}
        <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
          {/* Resplandor Cian superior derecho */}
          <div className="absolute -top-[10%] -right-[10%] w-[70vw] h-[70vw] bg-[#00C2FF]/5 blur-[120px] rounded-full" />
          
          {/* Luz Azul Royal central para dar profundidad */}
          <div className="absolute top-[20%] -left-[10%] w-[60vw] h-[60vw] bg-[#1A73E8]/3 blur-[140px] rounded-full" />
          
          {/* Brillo Cian inferior para el área de contacto */}
          <div className="absolute -bottom-[5%] right-[5%] w-[50vw] h-[50vw] bg-[#00C2FF]/4 blur-[100px] rounded-full" />
        </div>

        {/* CONTENIDO: Asegúrate de que los componentes tengan bg-transparent */}
        <div className="relative z-10">
          <Navbar />
          <Hero />
          
          {/* Divisores opcionales ultra-sutiles para separar conceptos sin cortar la luz */}
          <div className="h-px w-full bg-gradient-to-r from-transparent via-white/5 to-transparent" />
          
          <Features />
          <About />
          <Services />
          <Team />
          <Testimonial />
          <CTA />
          <Footer />
        </div>
      </div>
    </>
  );
}